import React from 'react';
import { motion } from 'framer-motion';
import { ProjectCard } from './ProjectCard';
interface WorkSectionProps {
  onProjectClick?: (title: string) => void;
}
export function WorkSection({
  onProjectClick
}: WorkSectionProps) {
  const projects = [{
    title: 'Web Messaging Ads Growth',
    subtitle: 'Monetization ecosystem strategy',
    mockupType: 'dashboard' as const,
    mediaUrl: 'https://cdn.magicpatterns.com/uploads/vWYr6MhuQSjfXgXg2Dc7t8/Web%20Messaging%20Ads%20Growth.mp4',
    mediaType: 'video' as const
  }, {
    title: 'Yohana Personal Assistant',
    subtitle: '0→1 Product launch',
    mockupType: 'dashboard' as const,
    mediaUrl: 'https://cdn.magicpatterns.com/uploads/kDNpPHSC9DGiiaZ7nz5VFZ/Yohana_Personal_Assistant.jpg',
    mediaType: 'image' as const
  }, {
    title: 'Unified Guidance Framework',
    subtitle: 'Experiment-driven product system',
    mockupType: 'mobile' as const,
    mediaUrl: 'https://cdn.magicpatterns.com/uploads/uBU1aLG7BqWBUUXH45G1Bg/Unified_Guidance_Framework_2.jpg',
    mediaType: 'image' as const
  }, {
    title: 'App by Phone',
    subtitle: 'Agent-Assisted Loan Application',
    mockupType: 'dashboard' as const,
    mediaUrl: 'https://cdn.magicpatterns.com/uploads/bSiD3s8SHN8WmLSqcxD8aM/App_by_phone_2.jpg',
    mediaType: 'image' as const
  }, {
    title: 'Accents Collective',
    subtitle: '0→1 Brand & Business Building',
    mockupType: 'mobile' as const,
    mediaUrl: 'https://cdn.magicpatterns.com/uploads/sR8TwRiGv8vtdvskBZYmYS/AC.jpg',
    mediaType: 'image' as const,
    comingSoon: true
  }, {
    title: 'Shop Ads Trust System',
    subtitle: 'Driving trust & conversion',
    mockupType: 'mobile' as const,
    mediaUrl: 'https://cdn.magicpatterns.com/uploads/6ERFYD75eR9mgA4mZf65sP/Shops_Ads_Trust_System.jpg',
    mediaType: 'image' as const
  }];
  return <section id="work" className="w-full px-6 md:px-12 py-24 bg-white" data-id="element-84" data-mp="3dll18ra79quz">
      <div className="max-w-7xl mx-auto" data-id="element-85" data-mp="3dmw66ufdt4no">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-86" data-mp="38u330azka4dp">
          <span className="text-stone-medium block mb-4 text-[16px] font-[400]" data-id="element-87" data-mp="drn4qn9tyki">
            SELECTED WORK
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-ink tracking-tight" data-id="element-88" data-mp="3mlrb836ow8pe">
            Case studies
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-8 lg:gap-12 text-[16px] font-[400]" data-id="element-89" data-mp="3hlmv4e9p1fzp">
          {projects.map((project, index) => <ProjectCard key={index} index={index} title={project.title} subtitle={project.subtitle} mockupType={project.mockupType} mediaUrl={project.mediaUrl} mediaType={project.mediaType} comingSoon={project.comingSoon} onClick={() => onProjectClick?.(project.title)} data-id="element-90" data-mp="267hnnba9unzm" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}